export default __webpack_public_path__ + "static/media/Tracktor.f0a23e88.png";